import React, { createContext, useMemo } from "react";
import { toast } from "react-toastify";
import AxiosService from "services/Axios";

const TopUpsAndPaymentsContext = createContext();

const TopUpsAndPaymentsProvider = ({ children }) => {
  const getAllTopUps = async () => {
    try {
      return await AxiosService.get(`${process.env.REACT_APP_API_URL}/user/top-ups`);
    } catch (error) {
      toast.error("데이터를 불러오는데 오류가 발생했습니다.", error);
    }
  };

  const createPayment = async (formData) => {
    try {
      return await AxiosService.post(`${process.env.REACT_APP_API_URL}/user/payments`, formData);
    } catch (error) {
      toast.error("데이터를 불러오는데 오류가 발생했습니다.", error);
    }
  };

  const updatePayment = async (formData) => {
    try {
      return await AxiosService.put(`${process.env.REACT_APP_API_URL}/user/payments`, formData);
    } catch (error) {
      toast.error("데이터를 불러오는데 오류가 발생했습니다.", error);
    }
  };

  const value = useMemo(
    () => ({
      getAllTopUps,
      createPayment,
      updatePayment,
    }),
    [getAllTopUps, createPayment, updatePayment],
  );

  return (
    <TopUpsAndPaymentsContext.Provider value={value}>
      {children}
    </TopUpsAndPaymentsContext.Provider>
  );
};

export { TopUpsAndPaymentsContext, TopUpsAndPaymentsProvider };
